<template lang="pug">
.v-page-banner.page-banner(v-if="data" )
	a.page-banner__link(v-if="data.link" :href="data.link.href")
	img.page-banner__image(v-if="data.image "
		:src="isMobile ? data.image?.mobileSrc : data.image?.src"
		:alt="data.image?.alt")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'

export default {
	mixins: [sourceMixin, isMobMixin],

	data() {
		return {
			data: null,
			isMobile: false
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	},

	watch: {
		isXs() {
			if(this.isXs) {
				this.isMobile = true
			} else {
				this.isMobile = false
			}
		}
	}
};
</script>